import { type FC } from "react";
import { InformationPage } from "../../../common/components/informationPage/InformationPage";

import { SAVED_CONFIGS_PAGE } from "../../../utils/url/staticUrls";
import { IMG_QUOTE_CONFIRMATION } from "../../../utils/url/staticResources";
import { Button } from "~/common/components/Button/Button";
import { useTranslation } from "react-i18next";

const LinearRequestQuoteSuccessPage: FC = () => {
  const { t } = useTranslation();

  return (
    <InformationPage.CenterContents className={"pb-30"}>
      <InformationPage.Title>{t("linear.request.quote.success.headline")}</InformationPage.Title>
      <InformationPage.Image src={IMG_QUOTE_CONFIRMATION} />
      <Button href={SAVED_CONFIGS_PAGE}>{t("linear.request.quote.success.btn.savedConfigs")}</Button>
    </InformationPage.CenterContents>
  );
};

export function createLinearRequestQuoteSuccessPage() {
  return <LinearRequestQuoteSuccessPage />;
}
